import * as yup from "yup";

export const createCategorySchema = (v, t, isEditMode) => {
  return yup.object().shape({
    name: v.string().required(),
    nameEn: v.string().required(),
  });
};
